import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from "@/router";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import {createFromIconfontCN} from '@ant-design/icons-vue';
import permission from '@/directives/permission'

import '@/assets/styles/common.scss';
import '@/assets/styles/font.css'// 字体库

// 创建 IconFont
const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_5057058_kuiify5b5d.js',
});

const pinia = createPinia()
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(Antd);

// 注册全局组件
app.component('IconFont', IconFont);

app.directive('permission', permission)

app.mount('#app');

